/* @generated from adl module ferovinum.datacontracts.supplier */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface SupplierRawRecord {
  id: common_strings.StringNE;
  name: common_strings.StringNE;
  shortName: (common_strings.StringNE|null);
  contactName: common_strings.StringNE;
  contactMobile: common_strings.StringNE;
  contactEmail: common_strings.StringNE;
  locale: common_strings.StringNE;
  status: common_strings.StringNE;
  createdAt: common.Instant;
  updatedAt: common.Instant;
  approvedCurrenciesJson: common_strings.StringNE;
  bankAccountId: (common_strings.StringNE|null);
}

export function makeSupplierRawRecord(
  input: {
    id: common_strings.StringNE,
    name: common_strings.StringNE,
    shortName?: (common_strings.StringNE|null),
    contactName: common_strings.StringNE,
    contactMobile: common_strings.StringNE,
    contactEmail: common_strings.StringNE,
    locale: common_strings.StringNE,
    status: common_strings.StringNE,
    createdAt: common.Instant,
    updatedAt: common.Instant,
    approvedCurrenciesJson: common_strings.StringNE,
    bankAccountId: (common_strings.StringNE|null),
  }
): SupplierRawRecord {
  return {
    id: input.id,
    name: input.name,
    shortName: input.shortName === undefined ? null : input.shortName,
    contactName: input.contactName,
    contactMobile: input.contactMobile,
    contactEmail: input.contactEmail,
    locale: input.locale,
    status: input.status,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
    approvedCurrenciesJson: input.approvedCurrenciesJson,
    bankAccountId: input.bankAccountId,
  };
}

const SupplierRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.supplier","decl":{"annotations":[{"value":{"datasetName":"raw_supplier"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"name","default":{"kind":"nothing"},"name":"name","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"shortName","default":{"kind":"just","value":null},"name":"shortName","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"contactName","default":{"kind":"nothing"},"name":"contactName","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactMobile","default":{"kind":"nothing"},"name":"contactMobile","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"contactEmail","default":{"kind":"nothing"},"name":"contactEmail","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"locale","default":{"kind":"nothing"},"name":"locale","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"status","default":{"kind":"nothing"},"name":"status","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"approvedCurrenciesJson","default":{"kind":"nothing"},"name":"approvedCurrenciesJson","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"bankAccountId","default":{"kind":"nothing"},"name":"bankAccountId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"SupplierRawRecord","version":{"kind":"nothing"}}};

export const snSupplierRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.supplier", name:"SupplierRawRecord"};

export function texprSupplierRawRecord(): ADL.ATypeExpr<SupplierRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snSupplierRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.supplier.SupplierRawRecord" : SupplierRawRecord_AST
};
